import {FC} from 'react';
import Input from '../../../../../../component/input/Input';
import EmailInput from '../../../../../../component/input/EmailInput';
import PhoneInput from '../../../../../../component/input/phoneInput/PhoneInput';
import Pencil from '../../../../../../assets/icons/Pencil';
import Globe from '../../../../../../assets/icons/Globe';
import PhoneHandset from '../../../../../../assets/icons/PhoneHandset';
import ImagePicker from './ImagePicker';
import {inputDefaults} from './types';
import * as css from '../AddLecturerPopup.css';

const LecturerTab: FC<{t: (k: string) => string}> = ({t}) => (
    <css.card>
        <ImagePicker />
        <css.fields>
            <css.fieldRow>
                <Input {...inputDefaults} name="firstName" text={t('firstName')} dataCy="addLecturerFirstName" icon={<Pencil width={20} height={20} />} />
                <Input {...inputDefaults} name="lastName" text={t('lastName')} dataCy="addLecturerLastName" icon={<Pencil width={20} height={20} />} />
            </css.fieldRow>
            <css.fieldRow>
                <PhoneInput name="phone" countryFieldName="country" text={t('phone')} events={{}} className="" icon={<PhoneHandset size={20} />} />
                <EmailInput name="email" text={t('email')} events={{}} className="" icon={<Globe width={22} height={22} />} />
            </css.fieldRow>
        </css.fields>
    </css.card>
);

export default LecturerTab;
